export default __webpack_public_path__ + "static/media/ultraballlegends.249ebe3b.png";